function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 9.05,
  d: "M17.67 60.75l28.66-28.67L17.67 3.42"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+YXJyb3ctcmlnaHQ8L3RpdGxlPjxwb2x5bGluZSBwb2ludHM9IjE3LjY3IDYwLjc1IDQ2LjMzIDMyLjA4IDE3LjY3IDMuNDIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iOS4wNSIvPjwvc3ZnPg==";
export { SvgArrowRight as ReactComponent };